var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2475 16.11L16.9275 14.43C17.1538 14.2066 17.44 14.0536 17.7516 13.9897C18.0631 13.9258 18.3865 13.9537 18.6825 14.07L20.73 14.8875C21.0291 15.0089 21.2856 15.2162 21.4671 15.4831C21.6486 15.75 21.747 16.0647 21.75 16.3875V20.1375C21.7482 20.3571 21.7021 20.5741 21.6143 20.7753C21.5265 20.9766 21.3989 21.158 21.2391 21.3087C21.0793 21.4594 20.8907 21.5761 20.6847 21.652C20.4786 21.7278 20.2593 21.7612 20.04 21.75C5.69248 20.8575 2.79748 8.70753 2.24998 4.05753C2.22456 3.82918 2.24778 3.59804 2.31811 3.37931C2.38844 3.16058 2.50429 2.95922 2.65803 2.78848C2.81177 2.61774 2.99992 2.48148 3.2101 2.38868C3.42028 2.29587 3.64772 2.24862 3.87748 2.25003H7.49998C7.82323 2.25099 8.13881 2.34863 8.40612 2.5304C8.67344 2.71217 8.88025 2.96976 8.99998 3.27003L9.81748 5.31753C9.93767 5.61233 9.96833 5.93601 9.90564 6.24814C9.84295 6.56027 9.68968 6.847 9.46498 7.07253L7.78498 8.75253C7.78498 8.75253 8.75248 15.3 15.2475 16.11Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.813ac6b62d7f721d9859d752331992b0.svg";
export { ForwardRef as ReactComponent };